<template>
  <div><router-view></router-view></div>
  
</template>

<script>

  export default{
    data(){
      return {
        showNav:false,
        theme:'dark'
      }
    },
    computed:{

    },
    methods:{

    }
  }
</script>

<style lang="less">



.size{
  width: 100%;
  height: 100%;
}

html,
body{
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

#app {
  .size;
}

.flex {
	display: flex;
	align-items: center;
	justify-content: center;
}

.flex-column-start{
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
}

.flex-row-start{
	display: flex;
	justify-content: flex-start;
	flex-direction: row;
}

</style>
